import { useState } from "react";

/**
 * Manages the open/target state for a single confirm dialog instance so call
 * sites don't need to hand-roll useState boilerplate. Kept in its own file
 * (not co-located with the ConfirmDialog component) since mixing a component
 * export with a hook export in one file breaks Vite's Fast Refresh.
 */
export function useConfirmDialog<T>() {
  const [target, setTarget] = useState<T | null>(null);
  return {
    target,
    isOpen: target !== null,
    request: (value: T) => setTarget(value),
    cancel: () => setTarget(null),
    clear: () => setTarget(null)
  };
}
